export default {"src":"/_next/static/media/pin-focus.a4b1cf8e.svg","height":22,"width":18,"blurWidth":0,"blurHeight":0};